<nz-card class="round-border p-4" [nzLoading]="!loaded">
    <a [routerLink]="['/game']">
        <nz-statistic [nzValue]="count | number" [nzTitle]="'game_common_name' | translate"></nz-statistic>
    </a>
</nz-card>